import * as React from "react";
import { FormField } from "./FormField.jsx";
// import * as cls from "./TextBox.module.scss";
export { TextBox }
/**
 * Текстовое поле ввода.
 *
 * Представляет элемент управления, который можно использовать для отображения
 * и редактирования обычного текста (однострочного или многострочного).
 * 
 * @summary Текстовое поле ввода.
 * @param {Object} props - Атрибуты элемента.
 * @param {React.RefObject} [props.inputRef] - Ссылка на элемент `input`.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.label] - Название и описание поля.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.required] - Обязательное для заполнения.
 * @param {boolean} [props.disabled] - Неактивно.
 * @param {boolean} [props.uncontrolled] - Неуправляемый компонент.
 * @param {boolean} [props.autoComplete] - Разрешено ли автозаполнение.
 * @param {string} [props.placeholder] - Отображать вместо пустого значения.
 * @param {int} [props.rows=1] - Количество строк.
 * @param {int} [props.minLength] - Минимальное количество символов.
 * @param {int} [props.maxLength] - Максимальное количество символов.
 * @param {string} [props.value] - Значение.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {TextBox} from "../personal-studio-components/form/index.js";
 * <TextBox
 * 	 label="Введите текст"
 * 	 required={true}
 *   onChange={(event) => {console.log(event.target.value);}}/>
 * @see {@link ../frame/EventListener.js}
 * @see [Windows.UI.Xaml.Controls.TextBox](https://learn.microsoft.com/ru-ru/uwp/api/windows.ui.xaml.controls.textbox)
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function TextBox(
  {
    inputRef,
    id,
    label,
    rows = 1,
    className,
    required,
    disabled,
    uncontrolled,
    autoComplete,
    placeholder,
    minLength,
    maxLength,
    value,
    onChange
  }) {
  if (rows > 1) {
    return (
      <FormField
        label={label}
        labelFor={id}
        required={required}
        className={className}>
        <textarea
          rows={rows}
          ref={inputRef}
          id={id}
          name={id}
          required={required}
          disabled={disabled}
          autoComplete={autoComplete}
          placeholder={placeholder}
          minLength={minLength}
          maxLength={maxLength}
          value={uncontrolled ? undefined : (value ?? "")}
          onChange={onChange} />
      </FormField>
    );
  }
  else {
    return (
      <FormField
        label={label}
        labelFor={id}
        required={required}
        className={className}>
        <input
          type="text"
          ref={inputRef}
          id={id}
          name={id}
          required={required}
          disabled={disabled}
          autoComplete={autoComplete}
          placeholder={placeholder}
          minLength={minLength}
          maxLength={maxLength}
          value={value ?? ""}
          onChange={onChange} />
      </FormField>
    );
  }
}
